import { render, staticRenderFns } from "./CustomIntegrationRow.vue?vue&type=template&id=1a386386&scoped=true&"
import script from "./CustomIntegrationRow.vue?vue&type=script&lang=js&"
export * from "./CustomIntegrationRow.vue?vue&type=script&lang=js&"
import style0 from "./CustomIntegrationRow.vue?vue&type=style&index=0&id=1a386386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a386386",
  null
  
)

export default component.exports